<template>
  <div :class="['formMultiselect', { 'formMultiselect--active': isOpen }]">
    <div class="formMultiselect__label">
      <multiselect
        ref="multiselect"
        :name="name"
        :value="computedValue"
        :options="options"
        :open-direction="openDirection"
        :placeholder="placeholder"
        :label="optionLabel"
        :allow-empty="allowEmpty"
        :searchable="searchable"
        :class="[
          'formMultiselect__input',
          {
            'formMultiselect__input--tall': isTall,
            'formMultiselect__input--small': isSmall,
            'formMultiselect__input--verySmall': isVerySmall,
            'multiselect--error': required && validate,
          },
        ]"
        @open="onOpen"
        @close="isOpen = false"
        @input="onInput"
      >
        <template slot="noResult"> Brak wyników wyszukiwania. </template>
        <template v-if="props.option.desc" slot="option" slot-scope="props">
          <div>
            <div class="formMultiselect__optionLabel">
              {{ props.option.label }}
            </div>
            <div>
              {{ props.option.desc }}
            </div>
          </div>
        </template>
      </multiselect>
      <span
        :class="[
          'formMultiselect__labelText',
          { 'formMultiselect__labelText--top': isOpen || select || placeholder },
        ]"
      >
        {{ label }}
      </span>
    </div>
    <slot name="error" />
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
  name: 'FormMultiselect',
  components: {
    Multiselect,
  },
  props: {
    name: {
      type: String,
      default: undefined,
    },
    label: {
      type: String,
      default: '',
    },
    isSmall: {
      type: Boolean,
      default: false,
    },
    isVerySmall: {
      type: Boolean,
      default: false,
    },
    isTall: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: true,
    },
    searchable: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Array,
      default: () => {},
    },
    openDirection: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
    optionLabel: {
      type: String,
      default: '',
    },
    keyValue: {
      type: String,
      default: '',
    },
    allowEmpty: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isOpen: false,
      select: null,
    };
  },
  computed: {
    computedValue() {
      return this.keyValue
        ? this.options.find(item => item[this.keyValue] === this.value)
        : this.options.find(item => item === this.value);
    },
    validate() {
      return !!(this.error && this.error[0]);
    },
  },

  methods: {
    onInput(e) {
      const value = this.keyValue && e ? e[this.keyValue] : e;
      this.$emit('input', value);
      this.$emit('emitObject', { name: this.name, value });
    },
    onOpen() {
      this.isOpen = true;
    },
  },
};
</script>

<style lang="scss">
.formMultiselect {
  $root: &;
  position: relative;
  padding-top: 1.5rem;

  &.is-invalid,
  &.required.touched {
    &::after {
      @include icomoon('wrong');
      font-size: 2.5rem;
      color: $cBadgeProm;
      position: absolute;
      top: 30%;
      right: 1.5rem;
      transform: translate(0, -50%);
    }
  }

  &__content {
    top: 100%;
  }

  &__input {
    height: 4.8rem;

    &--verySmall {
      height: 3.4rem;
      min-height: unset;
    }

    &--small {
      height: 4.2rem;
      min-height: unset;
    }

    &--tall {
      height: 6.8rem;
    }

    @include parent(#{$root}, '.is-invalid || .required.touched') {
      border: 2px solid $cBadgeProm;
      margin-bottom: 8px;
    }

    &:active ~ #{$root}__labelText,
    &:focus ~ #{$root}__labelText {
      top: 0;
    }

    @include parent(#{$root}, '.is-invalid || .passed || .failed') {
      & ~ #{$root}__labelText {
        top: 0;
      }
    }
  }

  &__label {
    display: block;
    position: relative;
  }

  &__labelText {
    //white-space: normal;
    overflow: hidden;
    max-width: calc(100% - 2rem);
    font-size: 1.4rem;
    line-height: 1.8rem;
    font-weight: 600;
    color: $cMainDark;
    background-color: $cWhite;
    margin-left: 1rem;
    padding: 0 1rem;
    position: absolute;
    pointer-events: none;
    top: 50%;
    transform: translate(0, -50%);
    left: 0;
    transition: top $trM;
    border-radius: 4px;

    &--top {
      top: 0;
    }
  }

  &__error {
    display: inline-block;
    color: $cBadgeProm;
    font-size: 1.4rem;
    line-height: 1.8rem;
    transition: color $tr, margin $tr;

    @include parent(#{$root}, '.is-invalid.failed') {
      margin: 0 0 0.8rem;
    }
  }

  &--active {
    #{$root}__labelText {
      z-index: 51;
    }
  }

  .multiselect__content-wrapper {
    max-height: 20rem !important;
  }

  &__optionLabel {
    font-weight: 700;
  }
}
</style>
